<form [formGroup]="dateFilterForm" class="form-custom">
   <mat-form-field class="lcs-date-range-input-form-field">
      <lcs-date-range-picker-input
         class="lcs-date-range-input-field"
         [dateRangePickerOptions]="dateRangePickerOptions"
         [initialContentFormValue]="initialContentFormValue"
      >
         <input
            lcsStartDate
            class="lcsDate"
            placeholder="From Date"
            formControlName="fromDate"
            [name]="'fromDate'"
            autocomplete="off" />
         <input lcsEndDate placeholder="To Date" formControlName="toDate" [name]="'toDate'" autocomplete="off"
      /></lcs-date-range-picker-input>
   </mat-form-field>
</form>
